import { APIUrlConstants, AppConstants } from "../../../common/APIConstants";
import RestEndPoint from "../../../common/RestEndPoint";

export default class GainLossSystemVarianceAPI {
  static getPMCSystemVarianceData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetPMCSystemVarianceData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static getPAASystemVarianceData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetPAASystemVarianceData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static saveSystemVarianceData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveSystemVarianceData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static getSystemVarianceAuditData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetSystemVarianceAuditData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
